var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Stack, Checkbox, FormControlLabel, TextField, Button, Divider } from '@mui/material';
import { inject, observer } from 'mobx-react';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import SmsIcon from '@mui/icons-material/Sms';
var SmsOptionsEditor = /** @class */ (function (_super) {
    __extends(SmsOptionsEditor, _super);
    function SmsOptionsEditor(props) {
        var _this = _super.call(this, props) || this;
        Object.defineProperty(_this, "refSmsInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.state = {};
        return _this;
    }
    Object.defineProperty(SmsOptionsEditor.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            return (_jsxs(Stack, __assign({ direction: "column", spacing: 2, className: "case-types-tab-panel" }, { children: [_jsxs("h4", { children: [_jsx(ConfirmationNumberIcon, {}, void 0), " ", (_b = this.props.languageStore) === null || _b === void 0 ? void 0 : _b.getLabel('Settings.Ticket.Option.Header')] }, void 0), _jsxs(Stack, __assign({ direction: "row", spacing: 2 }, { children: [_jsx(FormControlLabel, { label: (_c = this.props.languageStore) === null || _c === void 0 ? void 0 : _c.getLabel('Settings.Ticket.Option.Field.Expires'), sx: { whiteSpace: 'nowrap' }, control: _jsx(Checkbox, { color: "primary", checked: caseType === null || caseType === void 0 ? void 0 : caseType.linkExpires, onChange: function (e) { return _this.onLinkExpresChange(e); } }, void 0) }, void 0), _jsx(TextField, { disabled: !(caseType === null || caseType === void 0 ? void 0 : caseType.linkExpires), variant: "outlined", type: "number", fullWidth: true, onChange: function (e) { return _this.onLinkExpirationMinutesChange(e); }, value: caseType === null || caseType === void 0 ? void 0 : caseType.linkExpirationMinutes, label: "Interval" }, void 0), _jsx(FormControlLabel, { label: (_d = this.props.languageStore) === null || _d === void 0 ? void 0 : _d.getLabel('Settings.Ticket.Option.Field.Reused'), sx: { whiteSpace: 'nowrap' }, control: _jsx(Checkbox, { disabled: !(caseType === null || caseType === void 0 ? void 0 : caseType.linkExpires), color: "primary", checked: caseType === null || caseType === void 0 ? void 0 : caseType.linkCanBeReused, onChange: function (e) { return _this.onLinkCanBeReusedChange(e); } }, void 0) }, void 0), _jsx(TextField, { disabled: !(caseType === null || caseType === void 0 ? void 0 : caseType.linkExpires) || !(caseType === null || caseType === void 0 ? void 0 : caseType.linkCanBeReused), variant: "outlined", type: "number", fullWidth: true, onChange: function (e) { return _this.onLinkReuseMinutesChange(e); }, value: caseType === null || caseType === void 0 ? void 0 : caseType.linkReuseMinutes, label: "Interval" }, void 0)] }), void 0), _jsx(Divider, {}, void 0), _jsxs("h4", { children: [_jsx(SmsIcon, {}, void 0), " ", (_e = this.props.languageStore) === null || _e === void 0 ? void 0 : _e.getLabel('Settings.Ticket.SmsTemplate.Header'), _jsx(Button, __assign({ sx: { marginLeft: '15px' }, variant: "outlined", onClick: function () { return _this.appendLink(); } }, { children: (_f = this.props.languageStore) === null || _f === void 0 ? void 0 : _f.getLabel('Settings.Ticket.SmsTemplate.Field.AppendLinkButton') }), void 0)] }, void 0), _jsx(TextField, { variant: "outlined", onChange: function (e) { return _this.onSmsTemplateValueChanged(e); }, minRows: 5, maxRows: 5, inputRef: function (r) { return _this.refSmsInput = r; }, multiline: true, fullWidth: true, value: caseType === null || caseType === void 0 ? void 0 : caseType.smsTemplate, label: (_g = this.props.languageStore) === null || _g === void 0 ? void 0 : _g.getLabel('Settings.Ticket.SmsTemplate.Field.Template') }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(SmsOptionsEditor.prototype, "appendLink", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var link = '{link}';
                var updatedCaseType = __assign(__assign({}, caseType), { smsTemplate: caseType.smsTemplate ? caseType.smsTemplate + link : link });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    Object.defineProperty(SmsOptionsEditor.prototype, "onLinkExpresChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { linkExpires: e.target.checked });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    Object.defineProperty(SmsOptionsEditor.prototype, "onLinkCanBeReusedChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { linkCanBeReused: e.target.checked });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    Object.defineProperty(SmsOptionsEditor.prototype, "onLinkExpirationMinutesChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { linkExpirationMinutes: parseInt(e.target.value) });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    Object.defineProperty(SmsOptionsEditor.prototype, "onLinkReuseMinutesChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { linkReuseMinutes: parseInt(e.target.value) });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    Object.defineProperty(SmsOptionsEditor.prototype, "onSmsTemplateValueChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { smsTemplate: e.target.value });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    SmsOptionsEditor = __decorate([
        inject('caseTypesStore'),
        inject('languageStore'),
        observer
    ], SmsOptionsEditor);
    return SmsOptionsEditor;
}(React.Component));
export default SmsOptionsEditor;
